import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnactToggleButtonGroupComponent } from './enact-toggle-button-group.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    EnactToggleButtonGroupComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    EnactToggleButtonGroupComponent
  ]
})
export class EnactToggleButtonGroupModule { }